const CommonFields = ({ title, setTitle, summary, setSummary }) => (
  <>
    <div className="mt-3">
      <label className="block text-sm sm:text-base font-itcmedium text-[#6B7280] mb-1">Título <span className="text-red-500">*</span></label>
      <input
        type="text"
        placeholder="Escribe el título del anuncio"
        className="w-full px-4 py-2 border rounded placeholder:font-itcbook font-itcbook focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={title}
        onChange={e => setTitle(e.target.value)}
        maxLength={50}
      />
    </div>
    <div className="mt-3">
      <label className="block text-sm sm:text-base font-itcmedium text-[#6B7280] mb-1">Resumen <span className="text-red-500">*</span></label>
      <input
        type="text"
        placeholder="Escribe el resumen del anuncio"
        className="w-full px-4 py-2 border rounded font-itcbook placeholder:font-itcbook focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={summary}
        onChange={e => setSummary(e.target.value)}
        maxLength={200}
      />
    </div>
  </>
);

export default CommonFields;